import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=49bbf11a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=49bbf11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bbf11a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bbf11a')) {
      api.createRecord('49bbf11a', component.options)
    } else {
      api.reload('49bbf11a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=49bbf11a&scoped=true&", function () {
      api.rerender('49bbf11a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lwl6DKV45z4A/JS/comp/DocBox.vue"
export default component.exports